export default __webpack_public_path__ + "static/dizions-ISO-9001-2008-icon-f436669d6248edd157ed622314b3eb95.png";